import React from "react";

function ExplanationTriangleIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.51047 19.418H18.4883C18.7478 19.4179 19.0028 19.3506 19.2285 19.2224C19.4542 19.0943 19.6428 18.9099 19.7758 18.6871C19.9089 18.4643 19.9819 18.2108 19.9876 17.9513C19.9934 17.6919 19.9318 17.4354 19.8088 17.2069L11.8203 2.37094C11.2536 1.31906 9.74516 1.31906 9.17844 2.37094L1.19001 17.2069C1.06698 17.4354 1.00534 17.6919 1.01111 17.9513C1.01688 18.2108 1.08986 18.4643 1.22292 18.6871C1.35597 18.9099 1.54455 19.0943 1.77023 19.2224C1.99591 19.3506 2.25097 19.4179 2.51047 19.418Z"
        stroke="#F44336"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2306 7.65783L10.4997 13.3766L10.7683 7.66017C10.77 7.62363 10.7642 7.58713 10.7512 7.5529C10.7383 7.51868 10.7185 7.48745 10.6931 7.46113C10.6677 7.43481 10.6372 7.41394 10.6035 7.3998C10.5697 7.38567 10.5335 7.37856 10.4969 7.37892C10.461 7.37927 10.4255 7.38682 10.3925 7.40112C10.3595 7.41542 10.3297 7.43618 10.3049 7.46218C10.2801 7.48818 10.2607 7.51888 10.248 7.55249C10.2352 7.58609 10.2293 7.62191 10.2306 7.65783Z"
        stroke="#F44336"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 17.1211C10.3146 17.1211 10.1333 17.0661 9.97915 16.9631C9.82498 16.8601 9.70482 16.7137 9.63386 16.5424C9.56291 16.3711 9.54434 16.1826 9.58051 16.0007C9.61669 15.8188 9.70598 15.6518 9.83709 15.5207C9.9682 15.3896 10.1352 15.3003 10.3171 15.2641C10.499 15.2279 10.6875 15.2465 10.8588 15.3175C11.0301 15.3884 11.1765 15.5086 11.2795 15.6627C11.3825 15.8169 11.4375 15.9982 11.4375 16.1836C11.4375 16.4322 11.3387 16.6707 11.1629 16.8465C10.9871 17.0223 10.7486 17.1211 10.5 17.1211Z"
        fill="#F44336"
      />
    </svg>
  );
}

export default ExplanationTriangleIcon;
